import { useEffect, useState } from 'react';

import { subscribeToWelcomeEmailTemplates } from '../../../common/welcomeEmailApi.js';

// The global list of Welcome Email Templates, kept live while the Brugere tab is open.
export default function useWelcomeEmailTemplates(isActive) {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!isActive) return undefined;
        setLoading(true);
        return subscribeToWelcomeEmailTemplates(
            (next) => {
                setTemplates(next);
                setError('');
                setLoading(false);
            },
            (snapshotError) => {
                console.error('Error loading welcome email templates:', snapshotError);
                setError('Kunne ikke hente e-mailskabeloner.');
                setLoading(false);
            },
        );
    }, [isActive]);

    return { templates, loading, error };
}
